export enum MaritalStatus {
	CASADO = 'CASADO',
	DIVORCIADO = 'DIVORCIADO',
	OUTROS = 'OUTROS',
	SEPARADO = 'SEPARADO',
	SOLTEIRO = 'SOLTEIRO',
	UNIAO_ESTAVEL = 'UNIAO_ESTAVEL',
	VIUVO = 'VIUVO',
}
